// TODO: remove these
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */

type TagEvent = {
  name: string;
  payload?: any[];
};

export const settingUCUIDomains = () => {
  window.UC_UI_DOMAINS = {
    crossDomainConsentSharingIFrame: `${process.env.GATSBY_SITE_URL}/cross-domain-bridge.html`,
  };
};

let gtmLoaded = false;

export function loadGtm(gtmAccount: string) {
  if (gtmLoaded) return;
  const scriptGTM = document.createElement("script");
  scriptGTM.nonce = "'{SERVER-GENERATED-NONCE}'";
  scriptGTM.innerHTML = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;var n=d.querySelector('[nonce]');
n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmAccount}');
`;
  const head = document.querySelector("head");
  if (head) {
    head.insertBefore(scriptGTM, head.childNodes[0]);
    gtmLoaded = true;
  }
}

export function gtag(...args: any[]) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

/**
 * It loads a tag by using a custom event, which is set inside the data layer
 * @param event
 */
export function loadTag(event: TagEvent) {
  window.dataLayer = window.dataLayer || [];
  const { name, payload } = event;
  if (payload) {
    gtag(...payload);
  }
  window.dataLayer.push({
    event: name,
  });
}
